module.exports = __webpack_public_path__ + "img/icon-document.94ea7a9f.svg";